import { call, put, takeEvery } from 'redux-saga/effects';
import { CHANGE_USER_EMAIL_REQUEST } from '../../constants/user_emails.constants';
import { changeUserEmail } from '../../../requests/user_emails_requests/change_user_email_request';
import { changeUserEmailRequestSuccess, changeUserEmailRequestFailure } from '../../actions/user_emails_actions/change_user_email.actions';
import { message_success, message_error } from '../../../../../../components/Message';

function* changeUserEmailRequest({
    name, email, user_id, email_id,
}) {
    const {
        result, options, msg, error,
    } = yield call(changeUserEmail, user_id, { name, email }, email_id);
    if (result) {
        yield put(changeUserEmailRequestSuccess(options.person.emails));
        message_success('Email changed successfully!');
    } else {
        yield put(changeUserEmailRequestFailure(error));
        message_error(msg);
    }
}

export default function* changeUserEmailSaga() {
    yield takeEvery(CHANGE_USER_EMAIL_REQUEST, changeUserEmailRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_emails_sagas/change_user_email.saga.js